/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useRef, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { NavLink, useParams } from "react-router-dom";
import { ViewForm, Verify } from './blocks';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from "@mui/material";
import { PriceListTable } from './PriceListTable';
import { CustomerListView } from './CustomerListView';
import { Row, Col, Image, Space } from "antd";
import usePrevious from "../../../../Shared/components/Previous";
import { TextField } from "@mui/material";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { CustomForm } from './CustomForm';
import { emptyValidation } from "../../../../../helpers/validation";
import { AESDecrypt, AESEncrypt } from "../../../../../helpers/Crypto";
import { capitalizeFirstLetter, checkCRUDViewPermission, checkComponentPermission } from "../../../../../helpers/utilities";
import crudActions from "../../../../CRUD/redux/actions";
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import { toast } from 'react-toastify';
import { putRequest } from "../../../../../helpers/axiosClient";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { exportCommonFile } from "../../../../../helpers/utilities";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import moment from 'moment';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


export default function BulkPublishPriceView(props) {
    const { readDetails, readError, editDetails, editError, editLoader, editData } = useSelector(state => state.crudReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const dispatch = useDispatch();
    const { history } = props;
    const childRef = useRef('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const { type } = useParams();
    const { batchId } = useParams();
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const [customerSearch, setCustomerSearch] = useState('');
    const prevCustomerSearch = usePrevious(customerSearch);
    const [value, setValue] = useState("Price List");
    const [form, setForm] = useState({});
    const [batchForm, setBatchForm] = useState({ filterBy: 'ALL', productFilter: 'catalogue' });
    const [validate, setValidate] = useState('');
    const [visible, setVisible] = useState(false);
    const [error, setError] = useState({});
    const decryptedId = AESDecrypt(batchId);
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);

    const [agreements, setAgreements] = useState([]);
    const [createdProduct, setCreatedProduct] = useState(false);

    const [customers, setCustomers] = useState([]);
    const [customersList, setCustomersList] = useState([]);

    const timeoutRef = useRef(null);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [productNames, setProductNames] = useState({});
    const [productApplicable, setProductApplicable] = useState(false);
    const [verifyList, setVerifyList] = useState([]);
    const [verifyListAll, setVerifyListAll] = useState([]);
    const [verifyLoader, setVerifyLoader] = useState(true);
    const [validating, setValidating] = useState(false);
    const [topBar, setTopBar] = useState({});
    const [picker, setPicker] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    }


    const emptyState = () => {
        setError({});
    }
    const emptyStateInput = () => {
        setBatchForm({ filterBy: 'ALL', productFilter: 'catalogue' });
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setBatchForm({
                ...batchForm,
                [name]: e
            });
        } else {
            if (e.target.name === 'filterBy') {
                setError({});
            }
            setBatchForm({
                ...batchForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const createBatch = (e) => {
        e.preventDefault();
        let group = true;
        let customer = true;
        let emptyGroup = '';
        let emptyCustomer = '';
        if (batchForm.filterBy === 'GROUP') {
            emptyGroup = emptyValidation('Customer Group', batchForm.groupId, 'dropDown');
            group = emptyGroup.isValid;
        } else if (batchForm.filterBy === 'SPECIFIC') {
            emptyCustomer = emptyValidation('Customer', batchForm.customerId, 'dropDown');
            customer = emptyCustomer.isValid;
        }
        if (group && customer) {
            batchForm.batchId = decryptedId;
            history.push(`/admin/batch-process/price-list/${AESEncrypt(batchForm)}/outbound`);
        } else {
            setError({
                'groupId': emptyGroup.errors,
                'customerId': emptyCustomer.errors,
            })
        }
    }

    useEffect(() => {
        if (roleManagement !== '' && (checkCRUDViewPermission(`Outbound Price List`, 'view', history, 'Admin') ||
            checkCRUDViewPermission(`Inbound Price List`, 'view', history, 'Admin'))) {
            if (batchId === undefined || decryptedId === 0) {
                history.push("/admin/batch-process/price-list/outbound");
                return true;
            }
            dispatch({
                type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                    order: 'id desc'
                }
            });
            dispatch({
                type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
                filter: {
                    where: { "and": [{ customerBusinessId: { neq: null } }] },
                    order: 'id desc'
                },
            });
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "batches" });
            childRef?.current?.handleAdjustHeight();
        }
    }, [roleManagement]);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            setForm({ ...readDetails });
            if (validate === 'validate-update') {
                let names = readDetails?.batchAgreements?.filter((el) => !el.isApplicable)?.map((el) => {
                    return el?.product?.productName;
                });
                setProductNames(names);
                if (names && names.length > 0) {
                    setProductApplicable(true);
                }
            } else {
                setProductApplicable(false);
            }
            setAgreements(readDetails?.batchAgreements.sort(function (a, b) { return a.productId - b.productId }));
            setCustomers(readDetails?.batchCustomers);
            readDetails?.batchCustomers && readDetails?.batchCustomers.map((data) => {
                setCustomersList((prevState) => {
                    return [...prevState, data.customer];
                });
            });
            // let names = readDetails?.batchAgreements?.filter((el) => !el.isApplicable)?.map((el) => {
            //     return el?.isProductCreated;
            // });
            setCreatedProduct(readDetails?.batchAgreements?.filter((el) => (el?.isApplicable || el?.isProductCreated))?.length > 0 ? true : false);
            childRef?.current?.handleAdjustHeight();
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {
            toast.dismiss();
            toast.error(readError);
            history.push('/admin/batch-process/price-list/outbound');
        }
    }, [readDetails, readError]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                searchFunction(search, topBar);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    searchFunction(search, topBar);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if ((prevCustomerSearch !== undefined && customerSearch && customerSearch.length > 2 && prevCustomerSearch !== customerSearch) ||
            (prevCustomerSearch !== undefined && customerSearch === '' && prevCustomerSearch !== customerSearch)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (customerSearch === '') {
                searchCustomerFunction(customerSearch);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    searchCustomerFunction(customerSearch);
                }, 500);
            }
        }
    }, [customerSearch]);

    const searchCustomerFunction = (search) => {
        if (search === '') {
            setCustomers(readDetails?.batchCustomers);
        } else {
            let a = readDetails?.batchCustomers?.filter((el) => {
                return (el?.customer?.name?.match(new RegExp(search, "i")) ||
                    el?.customer?.serialNo?.match(new RegExp(search, "i")) ||
                    el?.customer?.mobile?.match(new RegExp(search, "i")))
            });
            setCustomers(a);
        }
    }

    const searchFunction = (search, topBar) => {
        let a = readDetails?.batchAgreements;

        if (search !== '') {
            a = readDetails?.batchAgreements?.filter((el) => {
                return (el?.product?.productName?.match(new RegExp(search, "i")) ||
                    el?.product?.universalproduct?.productId?.match(new RegExp(search, "i")) ||
                    el?.unit?.name?.match(new RegExp(search, "i")))
            });
        }

        if (topBar?.fromDate || topBar?.toDate) {
            if (topBar?.fromDate && topBar?.toDate) {
                a = a?.filter((el) => {
                    return (el?.fromDate >= moment(topBar?.fromDate).format('YYYY-MM-DD') &&
                        el?.toDate <= moment(topBar?.toDate).format('YYYY-MM-DD'))
                });
            } else if (topBar?.fromDate) {
                a = a?.filter((el) => {
                    return (el?.fromDate >= moment(topBar?.fromDate).format('YYYY-MM-DD'))
                });
            } else if (topBar?.toDate) {
                a = a?.filter((el) => {
                    return (el?.toDate <= moment(topBar?.toDate).format('YYYY-MM-DD'))
                });
            }
        }
        setAgreements(a);
    }

    const handlePublish = () => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "batches",
            title: "Price List",
            id: decryptedId,
            details: { batchStatus: 'PUBLISHED' }
        });
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            if (validate === 'validate' || validate === 'validate-update' || validate === 'update' || validate === 'accept') {
                setVerifyLoader(false);
                toast(`Price List ${validate === 'update' ? 'Validated & Updated' : validate === 'validate' ? 'Validated' : 'updated'} Successfully`);
                dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "batches" });
            } else if (validate === 'verify') {
                setVerifyList(editData);
                setVerifyListAll(editData);
                setVerifyLoader(false)
            } else {
                setVerifyLoader(false);
                toast(editDetails);
                history.push(`/admin/batch-process/price-list/${form?.inApp ? 'inbound' : 'outbound'}`);
            }
            if (validate === 'accept') {
                setValidate('');
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast(message);
        }
    }, [editDetails, editError]);

    const customObject = (details, id) => {
        let a = details && details.filter((el) => el.id === id);
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const chunkArray = (arr = [], size = 10) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };

    const handleValidate = async (type, data = []) => {
        let status = type;
        if (type === 'validate-update') {
            status = 'validate';
        }
        setValidate(type);
        let details = { status: status };

        if (data && data?.length > 0) {
            // perform chunked sequential PUT requests for approved items
            setValidating(true);
            const chunks = chunkArray(data, 300);
            try {
                for (let i = 0; i < chunks.length; i++) {
                    const d = { ...details, approved: chunks[i] };
                    await putRequest(`batches/${decryptedId}`, d);
                }
                toast.dismiss();
                toast.success('Approved items processed successfully');
                dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "batches" });
                history.push(`/admin/batch-process/price-list/${form?.inApp ? 'inbound' : 'outbound'}`);
            } catch (error) {
                const message = error?.response?.data?.message || error?.message || 'Failed to process approvals';
                toast.dismiss();
                toast.error(message);
            } finally {
                setValidating(false);
            }
        } else {
            // no approved items - fallback to existing flow
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "batches",
                title: "Price List",
                id: decryptedId,
                method: 'put',
                details: details
            });
        }
    }

    const handleValidateClose = (v) => {
        setProductApplicable(false);
        setValidate('');
        setProductNames({});
    }

    const handleDate = (value, name) => {
        let data = {
            ...topBar,
            [name]: value
        };
        setTopBar(data);
        searchFunction(search, data);
    }

    const handlePicker = () => {
        setPicker(!picker);
        let data = {
            ...topBar,
            fromDate: '',
            toDate: ''
        };
        setTopBar(data);
        searchFunction(search, data);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Batch Process', 'link': '' }]} />
            {
                (validate === 'verify' || validate === 'accept') ? <Verify editLoader={validating || editLoader}
                    handleSetList={(data) => setVerifyList(data)} listAll={verifyListAll}
                    handleValidate={(type, data) => handleValidate(type, data)} details={readDetails} list={verifyList} roleManagement={roleManagement}
                    classes={classes} clsx={clsx} loader={verifyLoader} /> :
                    <>
                        <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                            <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                                <CustomAccordion
                                    title={`${capitalizeFirstLetter(type)} Price List`}
                                    top={"0"}
                                    topVisible={"50px"}
                                    zIndex={9}
                                    showDetails={showDetails}
                                    index={0}
                                    ref={childRef}
                                    component={
                                        <>
                                            {
                                                !showDetails && readDetails &&
                                                <ViewForm
                                                    handleOpen={() => handleOpen()}
                                                    form={form}
                                                    createdProduct={createdProduct}
                                                    handlePublish={() => handlePublish()}
                                                    handleValidate={(type) => handleValidate(type)}
                                                    classes={classes} clsx={clsx} type={type} editLoader={editLoader} />
                                            }
                                            {
                                                showDetails && (
                                                    <div style={{ textAlign: "center" }}>
                                                        <div className={classes.loadMoreCircle}></div>
                                                    </div>
                                                )
                                            }
                                        </>
                                    }
                                />
                                <CustomAccordion
                                    title={"Price List Lines"}
                                    top={"49"}
                                    topVisible={"150px"}
                                    zIndex={7}
                                    showDetails={showDetails}
                                    index={1}
                                    ref={childRef}
                                    component={
                                        <>
                                            {
                                                !showDetails && readDetails &&
                                                <TabContext className={classes.viewBatchLines} value={value}>
                                                    <Row>
                                                        <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                                            {
                                                                roleManagement !== '' &&
                                                                ((!readDetails?.inApp && checkComponentPermission('Outbound Price List', 'Page', 'Product Search'))
                                                                    || (readDetails?.inApp && checkComponentPermission('Inbound Price List', 'Page', 'Product Search'))) && <>
                                                                    {
                                                                        value === 'Price List' ? <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}><TextField autoComplete='one-time-code'
                                                                            placeholder='Search'
                                                                            type='search'
                                                                            value={search}
                                                                            className={classes.comInput}
                                                                            required
                                                                            variant={'standard'}
                                                                            onChange={(e) => setSearch(e.target.value)}
                                                                            fullWidth
                                                                            onFocus={() => setIconAnimation(true)}
                                                                            onBlur={() => setIconAnimation(false)}
                                                                        /><Image
                                                                                src={SearchIcon}
                                                                                preview={false}
                                                                            />{
                                                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                                                    <Image
                                                                                        src={ClearIcon}
                                                                                        preview={false}
                                                                                    />
                                                                                </NavLink>
                                                                            }
                                                                        </div> : <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}><TextField autoComplete='one-time-code'
                                                                                placeholder='Search'
                                                                                type='search'
                                                                                className={classes.comInput}
                                                                                value={customerSearch}
                                                                                variant={'standard'}
                                                                                onChange={(e) => setCustomerSearch(e.target.value)}
                                                                                fullWidth
                                                                                onFocus={() => setIconAnimation(true)}
                                                                                onBlur={() => setIconAnimation(false)}
                                                                            /><Image
                                                                                src={SearchIcon}
                                                                                preview={false}
                                                                            />{
                                                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                                                    <Image
                                                                                        src={ClearIcon}
                                                                                        preview={false}
                                                                                    />
                                                                                </NavLink>
                                                                            }
                                                                        </div>
                                                                    }
                                                                </>
                                                            }
                                                        </Col>
                                                        <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                                            <div className={classes.overlFlowResponsiveDesign}>
                                                                <Space size={[20, 20]} direction="horizontal" align="center">
                                                                    {
                                                                        roleManagement !== '' && value === 'Price List' &&
                                                                        ((!readDetails?.inApp && checkComponentPermission('Outbound Price List', 'Page', 'Date Filter'))
                                                                            || (readDetails?.inApp && checkComponentPermission('Inbound Price List', 'Page', 'Date Filter'))) &&
                                                                        <>
                                                                            <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                                                                <Row>
                                                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                                        <NavLink to='#' onClick={() => handlePicker()}
                                                                                            className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder,
                                                                                                classes.dropDownWidth, classes.margint0, classes.dropDownPointer)} >
                                                                                            Date Filter
                                                                                            <Image src={DropDown} preview={false} />
                                                                                        </NavLink>
                                                                                    </Col>
                                                                                    {
                                                                                        picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                                            <div className={clsx(classes.dateFilterdateAdjust)}>
                                                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                                    <DesktopDatePicker
                                                                                                        fullWidth
                                                                                                        slots={{
                                                                                                            openPickerIcon: DateIcon
                                                                                                        }}
                                                                                                        views={['year', 'month', 'day']}
                                                                                                        allowKeyboardControl={false}
                                                                                                        label="From Date"
                                                                                                        //value={form?.fromDate}
                                                                                                        InputProps={{
                                                                                                            classes: {
                                                                                                                input: classes.textFieldColor,
                                                                                                            },
                                                                                                        }}
                                                                                                        onChange={(newValue, newError) => {
                                                                                                            if (newError?.validationError) {
                                                                                                                handleDate('', 'fromDate');
                                                                                                            } else {
                                                                                                                handleDate(newValue, 'fromDate');
                                                                                                            }
                                                                                                        }}
                                                                                                        format="dd/MM/yyyy"
                                                                                                    />
                                                                                                </LocalizationProvider>
                                                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                                                    <DesktopDatePicker
                                                                                                        fullWidth
                                                                                                        slots={{
                                                                                                            openPickerIcon: DateIcon
                                                                                                        }}
                                                                                                        minDate={new Date(form?.fromDate)}
                                                                                                        views={['year', 'month', 'day']}
                                                                                                        allowKeyboardControl={false}
                                                                                                        label="To Date"
                                                                                                        // value={form?.toDate}
                                                                                                        InputProps={{
                                                                                                            classes: {
                                                                                                                input: classes.textFieldColor,
                                                                                                            },
                                                                                                        }}
                                                                                                        onChange={(newValue, newError) => {
                                                                                                            if (newError?.validationError) {
                                                                                                                handleDate('', 'toDate')
                                                                                                            } else {
                                                                                                                handleDate(newValue, 'toDate')
                                                                                                            }
                                                                                                        }}
                                                                                                        format="dd/MM/yyyy"
                                                                                                    />
                                                                                                </LocalizationProvider>
                                                                                            </div>
                                                                                        </Col>
                                                                                    }
                                                                                </Row>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' &&
                                                                        ((!readDetails?.inApp && checkComponentPermission('Outbound Price List', 'Page', 'Export')) ||
                                                                            (readDetails?.inApp && checkComponentPermission('Inbound Price List', 'Page', 'Export'))) &&
                                                                        <NavLink
                                                                            to="#"
                                                                            onClick={() => {
                                                                                value === 'Price List' ? exportCommonFile(readDetails?.inApp ? 'Inbound Batch Price List' : 'Outbound Batch Price List', agreements, 'existing', []) :
                                                                                    exportCommonFile('Batch Customers List', customersList, 'existing', [])
                                                                            }}
                                                                            className={clsx(classes.customLink)}>
                                                                            <Image
                                                                                src={ExportIcon}
                                                                                preview={false}
                                                                                className={clsx(classes.antImage)}
                                                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                                        </NavLink>
                                                                    }
                                                                </Space>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Box className={clsx(classes.tabDesign, classes.margin20t)}>
                                                        {
                                                            !readDetails?.inApp && <TabList onChange={(event, newValue) => handleChange(event, newValue)}>
                                                                <Tab className={classes.Bordertab_1} label="Price List" value={"Price List"} />
                                                                <Tab className={classes.Bordertab_2} label="Customers" value={"Customers"} />
                                                            </TabList>
                                                        }
                                                    </Box>
                                                    <TabPanel className={classes.viewBatchLines} value={"Price List"}>
                                                        <PriceListTable
                                                            viewList={true}
                                                            selected={[]}
                                                            classes={classes}
                                                            clsx={clsx}
                                                            loadMore={!showDetails}
                                                            form={form}
                                                            details={agreements}
                                                            type={type}
                                                        />
                                                    </TabPanel>
                                                    <TabPanel className={classes.viewBatchLines} value={"Customers"}>
                                                        <CustomerListView
                                                            view={true}
                                                            classes={classes}
                                                            loadMore={!showDetails}
                                                            details={customers}
                                                            form={form}
                                                            clsx={clsx}
                                                            type={type} />
                                                    </TabPanel>
                                                </TabContext>
                                            }
                                            {
                                                showDetails && (
                                                    <div style={{ textAlign: "center" }}>
                                                        <div className={classes.loadMoreCircle}></div>
                                                    </div>
                                                )
                                            }
                                        </>
                                    }
                                />
                            </div>
                        </div>
                        <CustomForm
                            customObject={(details, id) => customObject(details, id)}
                            visible={visible}
                            handleClose={() => handleClose()}
                            createBatch={(e) => createBatch(e)}
                            changeHandler={(e, name) => changeHandler(e, name)}
                            form={batchForm}
                            error={error}
                            customerDetails={customerDetails}
                            customerGroupdetails={customerGroupdetails}
                        />
                        <CustomModal
                            onClose={(v) => handleValidateClose(v)}
                            yesButton={'Yes'}
                            noButton={'Cancel'}
                            title={'Validate and Update'}
                            visible={productApplicable}
                            loading={editLoader}
                            onOpen={() => handleValidate('update')}
                            text={
                                <>
                                    <p>The below list of Products is missing in your product Master, do you want to add them and Continue?</p>
                                    <div className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink',)}>Product Name</div>
                                    <Row gutter={20} className={classes.productNamesModal}>
                                        {
                                            productNames && productNames?.length > 0 ? productNames?.map((data, i) => (
                                                <Col span={12} className={classes.margin10t}>{data}</Col>
                                            )) : <Col span={24}>{'All procducts sucessfully validated'}</Col>
                                        }
                                    </Row>
                                </>
                            }
                        />
                    </>
            }
        </React.Fragment>
    )
}